import { useEffect, useLayoutEffect, useRef, useState } from "react";
import {  useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import GeneralAuthentication from "../general/GeneralAuthentication";
import TwoPanesPanel from "../general/TwoPanesPanel";
import MainPane from "../general/MainPane";
import LeftPaneGeneral from "../general/LeftPaneGeneral";
import BackToApplication from "../general/BackToApplication";
import { TwoHeading } from "../general/TwoHeading";
import Dropzone from "react-dropzone";
import * as theme from "../theme";
import Modal from "react-modal";
import PerfectScrollbar from "react-perfect-scrollbar";
import { getRecentQuotes, getRecentQuotesArray } from "../store/components";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import {
  addTransaction,
  getTransactions,
  //getAllTransactions,
  getTransactionsInformation,
  getTransactionsUpdating
} from "../store/transactions";
import {
  getMyQuotes,
  getClientDetailsUsingProspectId,
  getAllProspectsforCustomer,
} from "../store/myquotes";
import {
  getRowDetailsFromCustomerId,
  getMyCustomer,
  getMyCustomers,
  getCustomersTable,
  saveDocument,
  getAllDocuments,
  getAllTransactions,
  
} from "../store/mycustomers";
import { getAllPoliciesforCustomer } from "../store/mybinder";
import Loader3Orange from "../general/Loader3Orange";
import {
  changeScrollDivResponse,
  getScrollResponsesDiv,
} from "../store/quotes";
import axios from "axios";
import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";
import NormalText from "../general/NormalText";
import { PossibleClientDetailsStatus } from "../store/helperfuncs";
import { activateNavigationPage, getLanguageCode } from "../store/components";
import { OrangeButton } from "../general/OrangeButton";
import moment from "moment";
import { getPolicyStatusData } from "../store/policyStatus";
import { PossibleNaviationPages } from "./Navigation";
import Typography from "@material-ui/core/Typography";
import {
  Button,
  TextareaAutosize,
  TextField,
  FormControlLabel,
  FormGroup,
  Switch,
} from "@material-ui/core";
import { useLocation } from "react-router-dom";
import ActionButton from "../general/ActionButton";
import Select from "react-dropdown-select";
import ActionCentreText from "../general/ActionCetreText";
import ActionMessageButton from "../general/ActionMessageButton";
import { getIsLoading, getMyBinderList, getMyBinders } from "../store/mybinder";
import { dataForCHSInitialized } from "../store/qf";
import CustomerView from "./CustomerView"

const useStyles = makeStyles(theme.customMaterialUIClassForScrollBar);

const CustomerZoom = () => {
  const dispatch = useDispatch();
  const search = useLocation().search;
  var code = new URLSearchParams(search).get("id");
  const languagecode = useSelector(getLanguageCode);
  const isTransactionUpdating = useSelector(getTransactionsUpdating);
//   useEffect(() => {
//     // dispatch get all Documents
//     if(CustomerDetails?.prospectids && false)
//         dispatch(getAllDocuments(CustomerDetails.prospectids));
// }, [CustomerDetails])

  const policyStatusData = useSelector(getPolicyStatusData);
  let statusid = "625e922d580769d01b1c2160";
  const CustomerDetails = useSelector(
    getRowDetailsFromCustomerId({ customerid:code })
  );

  useEffect(() => {
    dispatch(
      activateNavigationPage({ pagecode: PossibleNaviationPages.mycustomers })
    );
    dispatch(getMyQuotes({'customerid': code}));
    dispatch(getMyBinders({ statusid }));
    dispatch(getAllTransactions(code));
    //dispatch(getAllDocuments(code));
  }, []);

  useEffect(() => {
    //console.log("UE CD: ", CustomerDetails)
    if(!CustomerDetails || !CustomerDetails.prospectids){
      dispatch(getMyCustomers(code));
      //dispatch(getMyCustomer(code));
    }
  }, [CustomerDetails] )


  useEffect(() => {
    //console.log("UE isTransactionUpdating: ", isTransactionUpdating);
    if(!isTransactionUpdating) {
      dispatch(getAllTransactions(code));
    }
  }, [isTransactionUpdating]);



  return (
    <GeneralAuthentication>
      <MainPane hideHelpOrTip={true}>
        {/* <TwoPanesPanel
          myquotesscreen={true}
          myquotesleftpane={
            <CustomerView customerid={code}></CustomerView>
          }
          myquotesrightpane={
            <CustomerZoomRightPane prospectid={code}></CustomerZoomRightPane>
          }
        ></TwoPanesPanel> */}
        <CustomerView customerid={code}></CustomerView>
      </MainPane>
    </GeneralAuthentication>
  );
};

//#region  Left Pane

const CustomerZoomLeftPane = (props) => {
  const dispatch = useDispatch();
  let history = useNavigate();
  let prospectid = props.prospectid;
  let customerid = props.prospectid;
  
  const prospectDetails = useSelector(
    getRowDetailsFromCustomerId({ prospectid })
  );
  console.log("CUSTOMER DETAILS:")
  console.log(prospectDetails)
  const CustomerDetails = useSelector(
    getRowDetailsFromCustomerId({ customerid })
  );
  const AllProspectDetails = useSelector(
    getAllProspectsforCustomer({ ...CustomerDetails })
  );
  const AllPoliciesDetails = useSelector(
    getAllPoliciesforCustomer({ ...CustomerDetails })
  );
  const dropzoneStyle = {
    alignItems: "center",
    padding: "20px",
    borderWidth: 2,
    width:"14rem",
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
   
  };
  const transInfo = useSelector(getTransactionsInformation);
  // useEffect(() => {
  //   setTimeout(() => {
  //     if(AllProspectDetails){
  //       var prospectIds = AllProspectDetails.map(x => x['App Info']);
  //       console.log(prospectIds[0])
  //       if(prospectIds[0])
  //         dispatch(getTransactions(prospectIds[0]));
  //     }
  //     if (AllPoliciesDetails) {
  //       var prospectIds = AllPoliciesDetails.map(x => x['App Info']);
  //       console.log(prospectIds)
  //       if(prospectIds[0])
  //         dispatch(getTransactions(prospectIds[0]));
  //     }
  //   }, 600);

  //   //dispatch(getTransactions(props.prospectid));
  // }, [dispatch])

  let [stateTransactions, setstateTransactions] = useState(transInfo);
  let typeOfDocuments = ['Applicaiton','Policy Document','Quotation','Risk Photo','Inspection report','Client email','Insurer email','Other email','Building valuation','Statement of Values','Schedule','Other'];

  let heightDivison = {
    backtoapp: "1%",
    quoteresults: "1.7rem",
    tableheader: "3rem",
    bottommargin: "1vmin",
    spaceBetweenHeaderContent: "0px",
    responses: "",
    display: "block"
  };
  heightDivison.responses = `calc(100% - ${heightDivison.backtoapp} - ${heightDivison.quoteresults} - ${heightDivison.tableheader} - ${heightDivison.bottommargin} - ${heightDivison.spaceBetweenHeaderContent})`;
  const mainContMargin = "5vw";
  const languagecode = useSelector(getLanguageCode);
  const PolicyHeaders = {
    first: "Type",
    second: "Insurer",
    third: "Start Date",
    fourth: "Expiry Date",
    fifth: "Status",
    sixth: "App Info",
    seventh: "Pol Info",
  };
  const RecentTranscationsHeaders = {
    first: "Date",
    second: "Details",
    third: "Undertaken By",
  };
  const FinancialsHeaders = {
    first: "Description",
    second: "Type",
    third: "Value",
  };
  const DocumentsandUploadsHeaders = {
    first: "File Name",
    second: "Description",
    third: "Download",
   
  };
  const DocumentsandUploadsHeadersExtended = {
    first: "File Name",
    second: "Description",
    third: "Download",
    fourth: "Type of Document",
    fifth: "Relevant Policy"
  }

  const UpcomingActionsHeaders = {
    first: "Action",
    second: "Policy",
    third: "Owner",
    fourth: "Date",
  };

  //console.log(prospectDetails.lastupdated);
  //console.log("prospectDetails.lastupdated")
  let [editCompanyDetail, seteditCompanyDetail] = useState(false);
  const [CompanyDetailsObj, setCompanyDetailsObj] = useState({
    "Company Name": CustomerDetails.company,
    "Web Address": "" ,
    Address: CustomerDetails.address?.streetNumber + " " + CustomerDetails.address?.street + " " + CustomerDetails.address?.city + " " +  CustomerDetails.address?.province,
    Vertical:
      props.AllProspectDetails && props.AllProspectDetails[0]?.vertical
        ? props.AllProspectDetails[0]?.vertical[props.languagecode]
        : "-",
    Operation: "Test",
  });
  let [bindModalState, setbindModalState] = useState(false);
  let [editTeamMembers, seteditTeamMembers] = useState(false);
  const [TeamMembersObj, setTeamMembersObj] = useState({
    "Position 1": "mom",
    "Position 2": "dad",
    "Position 3": "bros",
  });
  const [activeTable, setactiveTable] = useState("");
  const [uploadFileP, setuploadFile] = useState("");
  let [editContactDetails, seteditContactDetails] = useState(false);

  const [ContactDetailsObj, setContactDetailsObj] = useState([
    {
      Name: CustomerDetails.name,
      Number: CustomerDetails.phone,
      Email: CustomerDetails.email,
    },
  ]);

  useEffect(() => {
    console.log("inside use Effect");
    console.log(CustomerDetails)
    setContactDetailsObj([{
      Name: CustomerDetails.name,
      Number: CustomerDetails.phone,
      Email: CustomerDetails.email,
    }])
    setCompanyDetailsObj({
      "Company Name": CustomerDetails.company,
      "Web Address": "Test",
      Address: CustomerDetails.address?.streetNumber + " " + CustomerDetails.address?.street + " " + CustomerDetails.address?.city + " " +  CustomerDetails.address?.province + " " + CustomerDetails.address?.postalcode,
      Vertical:
        props.AllProspectDetails && props.AllProspectDetails[0]?.vertical
          ? props.AllProspectDetails[0]?.vertical[props.languagecode]
          : "-",
      Operation: "Test",
    })
  }, [CustomerDetails]);

  const [showTables, setShowTables] = useState({
    "customer-Contact-details": true,
    "customer-Team": true,
    "customer-Client-configuration": true,
    "customer-Policies": true,
    "customer-Upcoming-Actions": true,
    "customer-Transactions": true,
    "customer-Financials": true,
    "customer-Documents-and-Uploads": true,
  });

  const handleEditFormChange = (event, repObj, setStateFun) => {
    console.log(event.target);
    const fieldValue = event.target.value || event.target.innerHTML;
    const fieldName = event.target.getAttribute("objkey");
    const fieldKey = event.target.getAttribute("editkey");
    console.log(fieldName);
    console.log(fieldValue);
    if (!setStateFun) {
      const newFormData = { ...CompanyDetailsObj };
      newFormData[fieldName] = fieldValue;
      setCompanyDetailsObj(newFormData);
    } else if (fieldKey) {
      console.log("Updating keys");
      const oldKey = event.target.getAttribute("currentkey");
      const newFormData = { ...repObj };
      if (oldKey != fieldValue && fieldValue) {
        delete Object.assign(newFormData, {
          [fieldValue]: newFormData[oldKey],
        })[oldKey];
      } else if (fieldValue == "") {
        delete newFormData[oldKey];
      }
      setStateFun(newFormData);
    } else if (Array.isArray(repObj)) {
      const newFormData = [...repObj];
      console.log(event.target);
      var listKey = event.target.getAttribute("listkey");
      var objKey = event.target.getAttribute("objkey");
      if (listKey && objKey) {
        newFormData[listKey][objKey] = fieldValue;
        if (Object.keys(newFormData[0])[0] == objKey && fieldValue == "") {
          newFormData.splice(listKey, 1);
        }
        setStateFun(newFormData);
      }
    } else {
      const newFormData = { ...repObj };
      newFormData[fieldName] = fieldValue;
      setStateFun(newFormData);
    }
   
  };

  const [modelInput, setModelInput] = useState({
    'customerid': customerid,
    'document':'',
    'policy': '',
    'description': '',
    'file': {}
  })

  const addRow = ({ addObjectEntry, setter, data }) => {
    var newFormData = null;
    if (addObjectEntry) {
      newFormData = { ...data };
      var tempKey = "PositionNew";
      var incrementer = 0;
      while (newFormData[tempKey + incrementer]) {
        incrementer++;
      }
      newFormData[tempKey + incrementer] = "Name";
    } else {
      newFormData = [...data];
      var keys = Object.keys(data[0]);
      var tmpObj = {};
      for (var key of keys) {
        tmpObj[key] = "";
      }
      newFormData.push(tmpObj);
    }
    setter(newFormData);
  };

  const bigger = (parms) => {
    console.log(parms);
    var docu = document.getElementsByClassName(parms)[0];
    console.log(docu);
    if (docu.classList.contains("active")) {
      docu.classList.remove("active");
      setactiveTable("");
    } else {
      docu.classList.add("active");
      setactiveTable(parms);
    }
  };
  const showOnly = (parms) => {
    if (activeTable == "") {
      setactiveTable(parms);
    } else if (activeTable == parms) {
      setactiveTable("");
    }
  };

  const uploadFile = (e , fromDropZone=false) => {
    var file = null;
    if(fromDropZone){
      file = e
    }
    else{
      file = e.target.files[0];
    }
    console.log(file?.name)
    setuploadFile(file);
    setModelInput({...modelInput, 'file': file})
    return;
    
  };

  const sendtoBackend = () => {
    // console.log("Sending data to backend")
    // console.log(uploadFileP);
    // console.log(modelInput)
    const formData = new FormData();
    // formData.append("avatar", uploadFileP);
    console.log(modelInput)
    for(var key in modelInput){
     formData.append(key, modelInput[key]);
    }
    const config = {
      headers: {
        "Contetnt-Type": "multipart/form-data",
      },
    };
    console.log(formData)
    axios
      .post(
        process.env.REACT_APP_BASICSERVICE + "/api/customers/upload-document",
        formData,
        {
          headers: { "x-auth-token": localStorage.getItem("jwt") },
        }
      )
      .then((res) => {
        if(res.status == 200) {
          setbindModalState(false);
        }
      });

  }

  const updateCustomerDetailsPost = (data) => {
    console.log(data)
    var payload = {}
    payload.customerid = customerid;
    if(data.teamMembers){
      var teamMembers = [];
      for(var key in data.teamMembers){
        teamMembers.push({role: key, name: data.teamMembers[key]})
      }
      console.log(teamMembers)
      payload.teamMembers = teamMembers;
      
    }
    if(data.ContactDetails){
      console.log(data);
      payload.contactDetails = data.ContactDetails;
    }
    axios
      .post(
        process.env.REACT_APP_BASICSERVICE + "/api/customers/edit-details",
        payload,
        {
          headers: { "x-auth-token": localStorage.getItem("jwt") },
        }
      )
      .then((res) => {
        if(res.status == 200) {
          
        }
      });
  }

  const viewAllTxtBtn = (txt) => {
    return txt == activeTable ? "Back to Dashboard" : "View All";
  };

  const expandSection = (txt) => {
    return activeTable == txt ? `expandTable ${txt}` : `${txt}`;
  };

 
  var Policies_Leads = AllProspectDetails?.concat(AllPoliciesDetails);
  var cust_docs = []
  var cust_docs_extended = []
  if(prospectDetails && prospectDetails?.documents){
    for(var docu of prospectDetails?.documents){
      var tmp = {
        'fileName': docu.file.originalname,
        'description': docu.description,
        'documentDownload': docu.s3Info.key
      }
      var tmpExtended = {
        ...tmp,
        'typeofDocument' : docu.document,
        'relevantPolicy': docu.policy
      }
      cust_docs.push(tmp);
      cust_docs_extended.push(tmpExtended)
    }
  }
  
  return (
    <div>
      <div style={{ marginLeft: "5%", marginTop: "20px" }}>
        <BackToApplication
          text={"Back to customers"}
          onClick={() => {
            history.goBack();
            //document.location.href = `/myquotes`;
          }}
        ></BackToApplication>
      </div>
      <div style={{ display: "flex" }}>
        <Typography
          variant="h5"
          component="h5"
          style={{
            fontFamily: "GibsonSemiBd",
            fontSize: "5vmin",
            marginLeft: "30px",
            marginTop: "25px",
            color: theme.COLORS.primary_navyblue,
          }}
        >
          Client Dashboard
        </Typography>

        <div
          style={{
            fontSize: "2vmin",
            marginLeft: "20px",
            marginTop: "40px",
            marginBottom: "25px",
            backgroundColor: theme.COLORS.secondary_orange,
            borderRadius: "20px",
          }}
        >
          <Typography
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: "2vmin",
              marginLeft: "15px",
              marginRight: "15px",
              color: "white",
              textTransform: "capitalize",
            }}
          >
            {prospectDetails ? prospectDetails.status : "-"}
          </Typography>
        </div>
        <div
          style={{
            fontSize: "2vmin",
            marginLeft: "20px",
            marginTop: "40px",
            marginBottom: "25px",
            backgroundColor: theme.COLORS.secondary_skyblue,
            borderRadius: "20px",
          }}
        >
          <FormatDateTitle
            d={
              prospectDetails.lastupdated
                ? prospectDetails.lastupdated
                : new Date()
            }
          ></FormatDateTitle>
        </div>
      </div>

      <PerfectScrollbar style={{ height: "75vh" }}>
        <div className="customer-container">
          {activeTable == "" ? (
            <>
              <div className="customer-Company-details">
                <strong> Company Details </strong>
                <div className="customer-view-edit-btn">
                  <ActionButton
                    width="auto"
                    height="auto"
                    display="inline-flex"
                    text={editCompanyDetail ? "Save" : "View / Edit"}
                    onClick={() => {
                      if (editCompanyDetail) {
                        // we need to persist this data;
                      }
                      seteditCompanyDetail(!editCompanyDetail);
                    }} //() =>(document.location.href = href)
                    disabled={false}
                  ></ActionButton>
                </div>
                <table>
                  {editCompanyDetail ? (
                    <EditableRowVertical
                      data={CompanyDetailsObj}
                      handleEditFormChange={handleEditFormChange}
                    ></EditableRowVertical>
                  ) : (
                    <ReadOnlyRowVertical
                      data={CompanyDetailsObj}
                    ></ReadOnlyRowVertical>
                  )}
                </table>
              </div>
              <div className="customer-Contact-details">
                <strong> Contact Details </strong>
                <div className="customer-view-edit-btn">
                  {editContactDetails ? (
                    <AddCircleIcon
                      style={{
                        marginRight: "10px",
                      }}
                      onClick={() => {
                        addRow({
                          addObjectEntry: false,
                          setter: setContactDetailsObj,
                          data: ContactDetailsObj,
                        });
                      }}
                    ></AddCircleIcon>
                  ) : null}
                  <ActionButton
                    width="auto"
                    height="auto"
                    display="inline-flex"
                    text={editContactDetails ? "Save" : "View / Edit"}
                    onClick={() => {
                      if(editContactDetails) {
                        updateCustomerDetailsPost({'ContactDetails': ContactDetailsObj})
                      }
                      seteditContactDetails(!editContactDetails);
                    }} //() =>(document.location.href = href)
                    disabled={false}
                  ></ActionButton>
                </div>
                <table>
                  <tr>
                    <th>Contact Name</th>
                    <th>Contact Number</th>
                    <th>Email</th>
                  </tr>
                  {editContactDetails ? (
                    <EditableRowVertical
                      data={ContactDetailsObj}
                      handleEditFormChange={handleEditFormChange}
                      data_key={setContactDetailsObj}
                    ></EditableRowVertical>
                  ) : (
                    <ReadOnlyRowVertical
                      data={ContactDetailsObj}
                    ></ReadOnlyRowVertical>
                  )}
                </table>
              </div>
              <div className="customer-Team">
                <strong> Team </strong>
                <div className="customer-view-edit-btn">
                  {editTeamMembers ? (
                    <AddCircleIcon
                      style={{
                        marginRight: "10px",
                      }}
                      onClick={() => {
                        addRow({
                          addObjectEntry: true,
                          setter: setTeamMembersObj,
                          data: TeamMembersObj,
                        });
                      }}
                    ></AddCircleIcon>
                  ) : null}
                  <ActionButton
                    width="auto"
                    height="auto"
                    display="inline-flex"
                    text={editTeamMembers ? "Save" : "View / Edit"}
                    onClick={() => {
                      if(editTeamMembers){
                        //send to backend 
                        console.log(TeamMembersObj)
                        updateCustomerDetailsPost({'teamMembers': TeamMembersObj})
                      }
                      seteditTeamMembers(!editTeamMembers);
                    }} //() =>(document.location.href = href)
                    disabled={false}
                  ></ActionButton>
                </div>
                <table>
                  {editTeamMembers ? (
                    <EditableRowVertical
                      data={TeamMembersObj}
                      handleEditFormChange={handleEditFormChange}
                      data_key={setTeamMembersObj}
                      keyEditable={true}
                    ></EditableRowVertical>
                  ) : (
                    <ReadOnlyRowVertical
                      data={TeamMembersObj}
                    ></ReadOnlyRowVertical>
                  )}
                </table>
              </div>
              <div className="customer-Client-configuration">
                <strong> Client Configuration </strong>
                <div style={{ display: "flex" }}>
                  <FormGroup>
                    <FormControlLabel
                      label={"Auto-send client renewal app "}
                      className={"customer-toggle"}
                      style={{
                        ...theme.labelStyles,
                      }}
                      control={
                        <Switch
                          style={{
                            fontFamily: "GibsonSemiBd",
                            fontSize: "2.2vmin",
                            color: theme.COLORS.secondary_skyblue,
                          }}
                          onChange={() => console.log("Switched")}
                        />
                      }
                    />
                  </FormGroup>
                </div>
                <div style={{ display: "flex" }}>
                  <FormGroup>
                    <FormControlLabel
                      label={"Test option 1"}
                      className={"customer-toggle"}
                      style={{
                        ...theme.labelStyles,
                      }}
                      control={
                        <Switch
                          style={{
                            fontFamily: "GibsonSemiBd",
                            fontSize: "2.2vmin",
                            color: theme.COLORS.secondary_skyblue,
                          }}
                          onChange={() => console.log("Switched")}
                        />
                      }
                    />
                  </FormGroup>
                </div>
                <div style={{ display: "flex" }}>
                  <FormGroup>
                    <FormControlLabel
                      label={"Test option 2"}
                      className={"customer-toggle"}
                      style={{
                        ...theme.labelStyles,
                      }}
                      control={
                        <Switch
                          style={{
                            fontFamily: "GibsonSemiBd",
                            fontSize: "2.2vmin",
                            color: theme.COLORS.secondary_skyblue,
                          }}
                          onChange={() => console.log("Switched")}
                        />
                      }
                    />
                  </FormGroup>
                </div>
              </div>
            </>
          ) : null}
          {["", "customer-Policies"].includes(activeTable) ? (
            <div className={expandSection("customer-Policies")}>
              <LeftPaneGeneral
                heightDivison={heightDivison}
                headingSection={
                  <>
                    <TwoHeading
                      heading1={"Policies"}
                      fontSize="2vmin"
                      heading2={""}
                      display={"inline-flex"}
                    ></TwoHeading>
                    <ActionButton
                      width="auto"
                      height="auto"
                      display="inline-flex"
                      style={{ float:"right", order: 2, height: "2rem" }}
                      text={viewAllTxtBtn("customer-Policies")}
                      onClick={(e) => {
                        //bigger("customer-Policies")
                        showOnly("customer-Policies");
                      }} //() =>(document.location.href = href)
                      disabled={false}
                    ></ActionButton>
                  </>
                }
                tableHeaderSection={
                  <CustomerZoomTableHeader
                    columnHeadingsQuotes={PolicyHeaders}
                    key={"policies"}
                  ></CustomerZoomTableHeader>
                }
                tableRowsSection={
                  <CustomerZoomRowsSection
                    heightDivison={heightDivison}
                    prospectid={props.prospectid}
                  >
                    <CustomerZoomEachRow
                      heightDivison={heightDivison}
                      mainContMargin={mainContMargin}
                      rows={AllProspectDetails.concat(AllPoliciesDetails)}
                    ></CustomerZoomEachRow>
                  </CustomerZoomRowsSection>
                }
              ></LeftPaneGeneral>
            </div>
          ) : null}
          {["", "customer-Upcoming-Actions"].includes(activeTable) ? (
            <div className="customer-Upcoming-Actions">
              <LeftPaneGeneral
                heightDivison={heightDivison}
                headingSection={
                  <TwoHeading
                    heading1={"Upcoming Action"}
                    fontSize="2vmin"
                    heading2={""}
                  ></TwoHeading>
                }
                tableHeaderSection={
                  <CustomerZoomTableHeader
                    columnHeadingsQuotes={UpcomingActionsHeaders}
                    key={"upcoming_action"}
                  ></CustomerZoomTableHeader>
                }
                tableRowsSection={
                  <CustomerZoomRowsSection
                    heightDivison={heightDivison}
                    prospectid={props.prospectid}
                  >
                    <CustomerZoomEachRow
                      heightDivison={heightDivison}
                      mainContMargin={mainContMargin}
                      rows={[]}
                    ></CustomerZoomEachRow>
                  </CustomerZoomRowsSection>
                }
              ></LeftPaneGeneral>
            </div>
          ) : null}
          {["", "customer-Transactions"].includes(activeTable) ? (
            <div className={expandSection("customer-Transactions")}>
              <LeftPaneGeneral
                heightDivison={heightDivison}
                headingSection={
                  <>
                    <TwoHeading
                      heading1={"Transaction History"}
                      fontSize="2vmin"
                      heading2={""}
                      className={"customertableheader"}
                      display={"inline-flex"}
                    ></TwoHeading>
                    <ActionButton
                      width="auto"
                      height="auto"
                      
                      style={{ float:"right", order: 2, height: "2rem" }}
                      text={viewAllTxtBtn("customer-Transactions")}
                      onClick={(e) => {
                        showOnly("customer-Transactions");
                      }} //() =>(document.location.href = href)
                      disabled={false}
                    ></ActionButton>
                  </>
                }
                tableHeaderSection={
                  <CustomerZoomTableHeader
                    columnHeadingsQuotes={RecentTranscationsHeaders}
                    key={"transactions"}
                  ></CustomerZoomTableHeader>
                }
                tableRowsSection={
                  <CustomerZoomRowsSection
                    heightDivison={heightDivison}
                    prospectid={props.prospectid}
                  >
                    <CustomerZoomEachRow
                      heightDivison={heightDivison}
                      mainContMargin={mainContMargin}
                      activeTable={activeTable}
                      currentTable={"customer-Transactions"}
                      rows={transInfo.map(
                        ({ usertime, username, comments, tostatus }) => {
                          return {
                            usertime: usertime.split("T")[0],
                            comments,
                            username,
                          };
                        }
                      )}
                    ></CustomerZoomEachRow>
                  </CustomerZoomRowsSection>
                }
              ></LeftPaneGeneral>
            </div>
          ) : null}
          {["", "customer-Financials"].includes(activeTable) && false ? (
            <div className="customer-Financials">
              <LeftPaneGeneral
                heightDivison={heightDivison}
                headingSection={
                  <TwoHeading
                    heading1={"Financials"}
                    fontSize="2vmin"
                    heading2={""}
                  ></TwoHeading>
                }
                tableHeaderSection={
                  <CustomerZoomTableHeader
                    key={"financials"}
                    columnHeadingsQuotes={FinancialsHeaders}
                  ></CustomerZoomTableHeader>
                }
                tableRowsSection={
                  <CustomerZoomRowsSection
                    heightDivison={heightDivison}
                    prospectid={props.prospectid}
                  >
                    <CustomerZoomEachRow
                      heightDivison={heightDivison}
                      mainContMargin={mainContMargin}
                      rows={[]}
                    ></CustomerZoomEachRow>
                  </CustomerZoomRowsSection>
                }
              ></LeftPaneGeneral>
            </div>
          ) : null}
          {["", "customer-Documents-and-Uploads"].includes(activeTable) ? (

            <div className={expandSection("customer-Documents-and-Uploads")}>
              <LeftPaneGeneral
                heightDivison={heightDivison}
                headingSection={
                  <div>
                    <TwoHeading
                      heading1={"Documents and Uploads"}
                      fontSize="2vmin"
                      heading2={""}
                      display={"inline-flex"}
                    ></TwoHeading>
                    <ActionButton
                      width="auto"
                      height="auto"
                      display=""
                      style={{ float:"right", order: 2, height: "2rem" }}
                      text={viewAllTxtBtn("customer-Documents-and-Uploads")}
                      onClick={(e) => {
                        showOnly("customer-Documents-and-Uploads");
                      }} //() =>(document.location.href = href)
                      disabled={false}
                    ></ActionButton>
                    <ActionButton
                      width="auto"
                      height="auto"
                      display=""
                      style={{ float:"right", order: 2, height: "2rem" }}
                      text={"Add"}
                      onClick={(e) => {
                        setbindModalState(true);
                      }} //() =>(document.location.href = href)
                      disabled={false}
                    ></ActionButton>
                    <Modal
                      ariaHideApp={false}
                      isOpen={bindModalState}
                      ariaHideApp={true}
                      shouldCloseOnEsc={true}
                      style={{
                        overlay: {
                          position: "fixed",
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          backgroundColor: theme.COLORS.rgba_primary_navyblue,
                          color: "white",
                        },
                        content: {
                          height: "43vh",
                          width: "30vw",
                          position: "absolute",
                          // top: "1vh",
                          // left: "20vw",
                          // right: 0,
                          // bottom: 0,
                          left: "50%",
                          top: "50%",
                          transform: "translate(-50%, -50%)",
                          background: "white",
                          WebkitOverflowScrolling: "touch",
                          border: `8px solid white`,
                          borderRadius: "20px",
                          padding: 0,
                          overflowX: "hidden",
                          overflowY: "auto",
                        },
                      }}
                    >
                      <div
                        className="text-center py-3"
                        style={{
                          backgroundColor: theme.COLORS.secondary_skyblue,
                        }}
                      >
                        <span>
                          <h3 className="d-inline">Upload Document</h3>
                        </span>
                        <span
                          className="rounded-circle float-right mr-4 bg-dark px-2 py-0"
                          onClick={() => setbindModalState(false)}
                          role="button"
                        >
                          <h5>x</h5>
                        </span>
                      </div>
                      <div style={{ color: "black", textAlign:"center", marginTop:"5%" }}>
                        You can drag and drop or upload files directly to your client file
                        <div
                          style ={{
                            display: "flex",
                            justifyContent: "space-evenly",
                            alignItems:"center"
                          }}
                        >
                          <div>
                            <Dropzone
                              onDrop={(files) => {
                                uploadFile(files[0], true)
                              }}
                              
                              multiple={false}
                            >
                              {({ getRootProps, getInputProps }) => (
                                <section>
                                  <div {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <p style={dropzoneStyle}>
                                      Drop file here
                                    </p>
                                  </div>
                                </section>
                              )}
                            </Dropzone>
                          </div>
                                or
                          <div style = {{width: "45%"}}>
                            <label style={{
                              border: "1px solid #ccc",
                              display: "inline-block",
                              padding: "6px 12px",
                              cursor: "pointer",
                              width: "90%"
                            }}
                            for="myfile">Click here to Browse Computer and Add file:</label>
                            <input
                              style = {{display: "none"}}
                              type="file"
                              id="myfile"
                              name="myfile"
                              onChange={(e) => uploadFile(e)}
                            />
                          </div>
                        </div>
                      </div>
                      <div style={{ color: "black", display:"grid", gridTemplateColumns: "max-content 72%", gridGap:"13px" }}>
                            <label style={{ paddingRight:"4px"}}>File Attached</label>
                            <span>{uploadFileP?.name}</span>
                            <label style={{display:"inline", paddingRight:"4px"}}> Type of document:</label>
                            <select
                              onChange={(e)=> { setModelInput( {...modelInput, 'document': e.target.value}) }}
                            >
                              <option>Dropdown options</option>
                              {
                                typeOfDocuments.map(doc => {
                                  return (
                                    <option
                                      value={doc} > 
                                        {doc}
                                    </option>
                                  )
                                })
                              }
                            </select>
                            <label style={{display:"inline", paddingRight:"4px"}}> Relevant Policy:</label>
                            <select
                                onChange={(e)=> { 
                                  setModelInput( {...modelInput, 'policy': e.target.selectedOptions[0].getAttribute('text-key')}) 
                                }}
                            >
                              <option>Dropdown options</option>
                                {
                                  Policies_Leads.map(Lead => {
                                    var text_key = Lead.type + " " + Lead.insurer + " " + Lead['App Info']?.slice(-5);
                                    return (
                                      <option 
                                        text-key= {text_key}
                                        value={Lead['Pol Info'] ? Lead['Pol Info'] : Lead['App Info']} >
                                        { text_key }
                                      </option>
                                    )
                                  })

                                }
                              </select>
                            <label style={{display:"inline", paddingRight:"4px"}}>Description:</label>
                            <textarea
                              onChange={(e)=> { setModelInput( {...modelInput, 'description': e.target.value}) }}
                            ></textarea>
                      </div>
                        <ActionButton
                          width="auto"
                          height="auto"
                          display="inline-flex"
                          style={{ marginLeft: "auto", marginTop:"5%", order: 2, height: "3rem", width:"100%" }}
                          text={"Upload to Quotey"}
                          onClick={(e) => {
                            console.log("We gotta upload")
                            sendtoBackend(e)
                          }} //() =>(document.location.href = href)
                          disabled={false}
                      ></ActionButton>
                    </Modal>
                  </div>
                }
                
                tableHeaderSection={
                  <CustomerZoomTableHeader
                    columnHeadingsQuotes={DocumentsandUploadsHeaders}
                    columnHeadingsQuotesExtended={DocumentsandUploadsHeadersExtended}
                    activeTable={activeTable}
                    currentTable={"customer-Documents-and-Uploads"}
                    key={"transactions"}
                  ></CustomerZoomTableHeader>
                }
                tableRowsSection={
                  <CustomerZoomRowsSection
                    heightDivison={heightDivison}
                    prospectid={props.prospectid}
                  >
                    <CustomerZoomEachRow
                      heightDivison={heightDivison}
                      mainContMargin={mainContMargin}
                      rows={cust_docs}
                      rowsExtended={cust_docs_extended}
                      activeTable={activeTable}
                      currentTable={"customer-Documents-and-Uploads"}
                    ></CustomerZoomEachRow>
                  </CustomerZoomRowsSection>
                }
              ></LeftPaneGeneral>
            </div>
          ) : null}
        </div>
      </PerfectScrollbar>

      {/* <PerfectScrollbar style={{ height: "50vh" }}>
         
      </PerfectScrollbar> */}
    </div>
  );
};

const CustomerZoomRowsSection = (props) => {
  const dispatch = useDispatch();
  const { heightDivison } = props;

  // useEffect(() => {
  //   dispatch(getAllTransactions(props.prospectid));
  // }, [dispatch]);
  const transInfo = useSelector(getTransactionsInformation);
  return (
    <>
      {transInfo ? (
        props.children
      ) : (
        <div
          style={{
            width: "100%",
            height: heightDivison.responses,
          }}
        >
          <Loader3Orange></Loader3Orange>
        </div>
      )}
    </>
  );
};

const CustomerZoomEachRow = ({
  heightDivison,
  mainContMargin,
  rows,
  rowsExtended,
  activeTable,
  currentTable,
  
}) => {
  const isScrollResponsesDiv = useSelector(getScrollResponsesDiv);
  const responsesDiv = useRef(null);
  var transInfo = useSelector(getTransactionsInformation);
  if (rows) {
    if (activeTable && currentTable == activeTable) {
      transInfo = rows;
      if(rowsExtended){
        transInfo = rowsExtended
      }
    } else {
      transInfo = rows.slice(0, 2);
      // filter out columns not in summary view
    }
  }

  const dispatch = useDispatch();

  const ColoumnWidth = theme.columnWidthMyQuotesTable;
  ColoumnWidth.sixth = `calc(100% - ${ColoumnWidth.first} - ${ColoumnWidth.second} - ${ColoumnWidth.third} - ${ColoumnWidth.fourth} - ${ColoumnWidth.fifth} - ${ColoumnWidth.seventh} - ${ColoumnWidth.eighth} - ${ColoumnWidth.ninth})`;
  const classes = useStyles();

  return (
    <div
      style={{
        width: "100%",
        height: heightDivison.responses,
        paddingLeft: mainContMargin,
        paddingRight: isScrollResponsesDiv
          ? `calc(${mainContMargin} - ${theme.SCALES.scrollbarThickness} - ${theme.SCALES.responsesSpacesBetweenScroll})`
          : mainContMargin,
      }}
    >
      <div
        className={classes.responses}
        style={{
          width: "100%",
          paddingRight: isScrollResponsesDiv
            ? theme.SCALES.responsesSpacesBetweenScroll
            : "0px",
          height: "100%",
        }}
        ref={responsesDiv}
      >
        {transInfo.map((p, index) => (
          <ProspectRow
            key={index + "__V"}
            prospect={p}
            custom={rows}
          ></ProspectRow>
        ))}
      </div>
    </div>
  );
};

const ProspectRow = ({ prospect, custom }) => {
  const ColoumnWidth = theme.columnWidthMyQuotesTable;
  ColoumnWidth.sixth = `calc(100% - ${ColoumnWidth.first} - ${ColoumnWidth.second} - ${ColoumnWidth.third} - ${ColoumnWidth.fourth} - ${ColoumnWidth.fifth} - ${ColoumnWidth.seventh} - ${ColoumnWidth.eighth} - ${ColoumnWidth.ninth})`;
  const history = useNavigate();
  const commonStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const borderCommon = {
    borderRight: "1px solid #D8D8D8",
  };
  const getDocument = (docKey) => {
    console.log(docKey);
    axios
      .get(
        process.env.REACT_APP_BASICSERVICE + "/api/customers/get-document?key="+ docKey,
        {
          headers: { "x-auth-token": localStorage.getItem("jwt") },
        }
      )
      .then((res) => {
        console.log("RESULT");
        console.log(res.data.url);
        const link = document.createElement('a');
        link.href = res.data.url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });

  }
  var renderCustomRow = false;
  var arr_keys = Object.keys(prospect);
  //console.log(arr_keys);
  var width = 100 / arr_keys.length + "%";
  var btnWidth = (100 / arr_keys.length) * 0.6 + "%";

  //console.log(prospect)
  return (
    <div
      className={"row"}
      style={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
        height: "60px",
        maxHeight: 75,
        borderBottom: "1px solid " + theme.COLORS.tertiary_ligthindigo,
        borderTop: "1px solid " + theme.COLORS.tertiary_ligthindigo,
        backgroundColor: "white",
      }}
    >
      {custom ? (
        arr_keys.map((key, idx) => {
          if (["App Info", "Pol Info"].includes(key) && prospect[key] != "") {
            var href =
              key == "App Info"
                ? `/quotes?id=${prospect[key]}`
                : `/binder?id=${prospect[key]}`;
            return (
              <div style={{ width: width, ...commonStyle }}>
                <ActionButton
                  width="auto"
                  height="auto"
                  text={"View / Edit"}
                  onClick={() => history.push(href)} //() =>(document.location.href = href)
                  disabled={false}
                ></ActionButton>
              </div>
            );
          }
          else if (["documentDownload"].includes(key) ) {
            return (
            <div style={{ width: width, ...commonStyle }}>
                <ActionButton
                  width="auto"
                  height="auto"
                  text={"Download"}
                  onClick={() => getDocument(prospect[key])} //() =>(document.location.href = href)
                  disabled={false}
                ></ActionButton>
              </div>
            );
          } 
          else
            return (
              <div
                className={"tabledata"}
                style={{ width: width, ...commonStyle, textAlign: "center" }}
              >
                {prospect[key]}
              </div>
            );
        })
      ) : (
        <>
          <div
            style={{
              ...commonStyle,
              width: "15%",
              ...borderCommon,
            }}
          >
            {/* <NormalText
          text={prospectDetails.lastupdated}//{prospectDetails.brokername}
          fontWeight={"normal"}
          fontSize={15}
          color="grey"
        ></NormalText> */}
            <FormateDate d={prospect.usertime}></FormateDate>
          </div>
          <div
            style={{
              ...commonStyle,
              width: "15%",
              ...borderCommon,
            }}
          >
            <NormalText
              text={prospect.tostatus}
              fontWeight={"normal"}
              fontSize={15}
              color="grey"
            ></NormalText>
          </div>
          <div
            style={{
              ...commonStyle,
              width: "15%",
              ...borderCommon,
            }}
          >
            <NormalText
              text={prospect.username}
              fontWeight={"normal"}
              fontSize={15}
              color="grey"
            ></NormalText>
          </div>
          <div
            style={{
              ...commonStyle,
              width: "15%",
              ...borderCommon,
            }}
          >
            <FormateDate d={prospect.usertime}></FormateDate>
          </div>
          <div
            style={{
              ...commonStyle,
              width: "15%",
              ...borderCommon,
            }}
          >
            <NormalText
              text={prospect.premium}
              fontWeight={"normal"}
              fontSize={15}
              color="grey"
            ></NormalText>
          </div>
          <div
            style={{
              ...commonStyle,
              width: "25%",
              ...borderCommon,
            }}
          >
            <NormalText
              text={prospect.comments}
              fontWeight={"normal"}
              fontSize={15}
              color="grey"
            ></NormalText>
          </div>
        </>
      )}
    </div>
  );
};

const FormateDate = ({ d }) => {
  let date = new Date(d);
  let dateFormatted = moment(date, "DD/MM/YYYY").format("DD MMM YYYY h:mma");
  return (
    <NormalText
      text={dateFormatted}
      fontWeight={"normal"}
      fontSize={15}
      color="grey"
    ></NormalText>
  );
};

const FormatDateTitle = ({ d }) => {
  let date = new Date(d);
  let dateFormatted = moment(date, "DD/MM/YYYY").format("DD MMM YYYY");
  return (
    <Typography
      style={{
        fontFamily: "GibsonSemiBd",
        fontSize: "2vmin",
        marginLeft: "15px",
        marginRight: "15px",
        color: "white",
      }}
    >
      Follow-up: {dateFormatted}
    </Typography>
  );
};

const CustomerZoomTableHeader = (props) => {
  var columnHeadingsQuotes = {
    first: "Date",
    second: "Status/Action",
    third: "User",
    fourth: "Effective Date",
    fifth: "Premium",
    sixth: "Comments",
  };

  if (props?.columnHeadingsQuotes) {
    for (var key in props.columnHeadingsQuotes) {
      columnHeadingsQuotes[key] = props.columnHeadingsQuotes[key];
    }
    // columnHeadingsQuotes = {
    //     first: props.columnHeadingsQuotes.first,
    //     second: props.columnHeadingsQuotes.second,
    //     third: props.columnHeadingsQuotes.third,
    //     fourth: props.columnHeadingsQuotes.fourth,
    //     fifth: props.columnHeadingsQuotes.fifth,
    //     sixth: props.columnHeadingsQuotes.sixth,
    //   };
  }

  const CommonStyleColumn = {
    color: "white",
    fontFamily: "GibsonRegular",
    alignSelf: "center",
    borderRight: `1px solid white`,
    height: "100%",
    display: "flex",
    alignItems: "center",
    letterSpacing: 1,
    justifyContent: "center",
    textAlign: "center",
    fontSize: "1.5vmin",
  };
  const BorderRaidus = 8;
  const headingStyle = {
    height: "77%",
    width: "100%",
    backgroundColor: theme.COLORS.primary_navyblue,
    borderTopLeftRadius: BorderRaidus,
    borderTopRightRadius: BorderRaidus,
    display: "flex",
    flexDirection: "row",
  };
  if (props?.columnHeadingsQuotesExtended && props.activeTable == props.currentTable && props.activeTable) {
    var arr_keys = Object.keys(props?.columnHeadingsQuotesExtended);
    var width = 100 / arr_keys.length + "%";
    //console.log("width:", width)
    return (
      <div style={headingStyle}>
        {arr_keys.map((key, idx) => {
          return (
            <div
              className={"headerrow"}
              style={{
                width: width,
                ...CommonStyleColumn,
                fontSize: "1.5vmin",
              }}
            >
              {props.columnHeadingsQuotesExtended[key]}
            </div>
          );
        })}
      </div>
    );
  }
  else if (props?.columnHeadingsQuotes) {
    var arr_keys = Object.keys(props?.columnHeadingsQuotes);
    var width = 100 / arr_keys.length + "%";
    //console.log("width:", width)
    return (
      <div style={headingStyle}>
        {arr_keys.map((key, idx) => {
          return (
            <div
              className={"headerrow"}
              style={{
                width: width,
                ...CommonStyleColumn,
                fontSize: "1.5vmin",
              }}
            >
              {props.columnHeadingsQuotes[key]}
            </div>
          );
        })}
      </div>
    );
  }
  else
    return (
      <div style={headingStyle}>
        <div style={{ width: "15%", ...CommonStyleColumn }}>
          {columnHeadingsQuotes.first}
        </div>
        <div style={{ width: "15%", ...CommonStyleColumn }}>
          {columnHeadingsQuotes.second}
        </div>
        <div style={{ width: "15%", ...CommonStyleColumn }}>
          {columnHeadingsQuotes.third}
        </div>
        <div style={{ width: "15%", ...CommonStyleColumn }}>
          {columnHeadingsQuotes.fourth}
        </div>
        <div style={{ width: "15%", ...CommonStyleColumn }}>
          {columnHeadingsQuotes.fifth}
        </div>
        <div
          style={{
            width: "25%",
            ...CommonStyleColumn,
          }}
        >
          {columnHeadingsQuotes.sixth}
        </div>
      </div>
    );
};

const ReadOnlyRowVertical = (props) => {
  if (Array.isArray(props.data)) {
    //console.log(props.data)
    return (
      <tbody>
        {props.data.map((obj, index) => (
          <tr key={index}>
            {Object.keys(obj).map((keyx, idx) => (
              <td key={idx}>{obj[keyx]}</td>
            ))}
          </tr>
        ))}
      </tbody>
    );
  } else {
    return (
      <tbody>
        {Object.keys(props.data).map((p, index) => (
          <tr key={index}>
            <td>{p}</td>
            <td>{props.data[p]}</td>
          </tr>
        ))}
      </tbody>
    );
  }
};
const EditableRowVertical = (props) => {
  //console.log(props)
  if (Array.isArray(props.data)) {
    return (
      <tbody>
        {props.data.map((obj, index) => (
          <tr>
            {Object.keys(obj).map((keyx, idx) => (
              <td
                key={idx}
                suppressContentEditableWarning={true}
                contentEditable="true"
                listkey={index}
                objkey={keyx}
                onBlur={(e) =>
                  props.handleEditFormChange(e, props.data, props.data_key)
                }
                style={{
                  backgroundColor: "lightyellow",
                  border: "1px solid #000",
                }}
              >
                {obj[keyx]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    );
  }
  return (
    <tbody>
      {Object.keys(props.data).map((p, index) => (
        <tr key={index}>
          {props.keyEditable ? (
            <td
              onBlur={(e) =>
                props.handleEditFormChange(e, props.data, props.data_key)
              }
              suppressContentEditableWarning={true}
              contentEditable="true"
              currentkey={p}
              editkey="true"
              style={{
                backgroundColor: "lightyellow",
                border: "1px solid #000",
              }}
            >
              {p}
            </td>
          ) : (
            <td>{p}</td>
          )}
          <td
            key={p}
            suppressContentEditableWarning={true}
            contentEditable="true"
            objkey={p}
            value={props.data[p]}
            onBlur={(e) =>
              props.handleEditFormChange(e, props.data, props.data_key)
            }
            style={{ backgroundColor: "lightyellow", border: "1px solid #000" }}
          >
            {/* <td>
          <input
            onChange={props.handleEditFormChange}
            value={props.data[p]} 
          >
          </input> */}
            {props.data[p]}
          </td>
        </tr>
      ))}
    </tbody>
  );
};
//#endregion

//#region Right Pane
const CustomerZoomRightPane = (props) => {
  const [modalState, setModal] = useState(false);
  const [hideStatus, setHideStatus] = useState(false);
  const [newStatus, setNewStatus] = useState(null);
  const [comment, setComment] = useState(null);
  const dispatch = useDispatch();
  const prospectid = props.prospectid;
  const prospectDetails = useSelector(
    getRowDetailsFromCustomerId({ prospectid })
  );
  const statusOptions = [
    { value: "New", label: "New" },
    { value: "App In Progress", label: "App In Progress" },
    { value: "Close - Incomplete Info", label: "Close - Incomplete Info" },
    { value: "App Completed", label: "App Completed" },
    { value: "In Market", label: "In Market" },
    { value: "Close - No Insurer", label: "Close - No Insurer" },
    { value: "Quoted", label: "Quoted" },
    { value: "Not Interested", label: "Not Interested" },
    { value: "Sold", label: "Sold" },
  ];

  let commonActoinMessageButton = {
    height: "25%",
    marginBottom: "2%",
    marginTop: "6%",
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        paddingBottom: "17vh",
        paddingTop: "6vh",
        paddingLeft: theme.SCALES.actionPaddingLeft,
        paddingRight: theme.SCALES.actionPaddingRight,
        height: "100%",
      }}
    >
      <ActionCentreText id="info"></ActionCentreText>

      {/* <div style={{ ...commonActoinMessageButton }}>
        <ActionMessageButton
          text={"Add comments or other information to this prospect file"}
          buttonText={"Add Comment"}
          buttonClick={() => {
            setModal(true);
            setHideStatus(false);
            setNewStatus(null);
          }}
          buttonTextSize="min(max(0.7vw,10px),0.8vw)"
        ></ActionMessageButton>
      </div> */}



      <Modal
        size="md"
        isOpen={modalState}
        ariaHideApp={false}
        shouldCloseOnEsc={false}
        centered
        style={{
          overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: theme.COLORS.rgba_primary_navyblue,
          },
          justifyContent: "center",
          content: {
            height: "40%",
            width: "16%",
            position: "absolute",
            top: "20%",
            left: "40%",
            background: "#eef3f6",
            WebkitOverflowScrolling: "touch",
            border: "8px solid " + theme.COLORS.primary_navyblue,
            borderRadius: "20px",
            padding: 10,
            overflowY:"auto",
          },
        }}
      >
        <PerfectScrollbar>
          <div>
            <div style={{ margin: "15px" }}>
              <NormalText>
                {newStatus
                  ? "Please select a status and enter comment"
                  : "Please enter a comment"}
              </NormalText>
            </div>
            {hideStatus ? (
              <div style={{ margin: "10px" }}>
                <FormControl variant="filled" sx={{ m: 0, minWidth: 260 }}>
                  <Select
                    options={statusOptions}
                    placeholder="Select a status"
                    style={{
                      width: "13vw",
                      backgroundColor: "#ffffff",
                      borderRadius: "5px",
                    }}
                    onChange={function (e) {
                      setNewStatus(e[0].value);
                    }}
                  />
                </FormControl>
              </div>
            ) : (
              <div />
            )}
            <div style={{ margin: "10px" }}>
              <FormControl sx={{ m: 0, minWidth: 260 }}>
                <TextareaAutosize
                  id="txtComment"
                  placeholder="Enter a comment"
                  style={{
                    backgroundColor: "#ffffff",
                    width: "13vw",
                    height: "18vh",
                  }}
                  className="form-control"
                  onChange={(x) => setComment(x.target.value)}
                />
              </FormControl>
            </div>
            <div className="m-2" style={{ width: "30%", float: "right" }}>
              <ActionButton
                text="Save"
                onClick={() => {
                  let data = {
                    prospectid: prospectid,
                    oldstatus: prospectDetails.status,
                    newstatus: newStatus == "-" ? null : newStatus,
                    comment: comment == "-" ? null : comment,
                  };
                  dispatch(addTransaction(data)).then(
                    setTimeout(() => {
                      if (data.newstatus) dispatch(getMyQuotes(null));
                      dispatch(getTransactions(prospectid));
                    }, 100)
                  );
                  setModal(false);
                }}
              ></ActionButton>
            </div>
            <div className="m-2" style={{ width: "30%", float: "right" }}>
              <ActionButton
                text="Cancel"
                onClick={() => setModal(false)}
              ></ActionButton>
            </div>
          </div>
        </PerfectScrollbar>
      </Modal>
    </div>
  );
};
//#endregion

export default CustomerZoom;